/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagetaken2Inputs */

const en_ticketpagetaken2 = /** @type {(inputs: Ticketpagetaken2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Given out`)
};

const de_ticketpagetaken2 = /** @type {(inputs: Ticketpagetaken2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergeben`)
};

/**
* | output |
* | --- |
* | "Given out" |
*
* @param {Ticketpagetaken2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagetaken2 = /** @type {((inputs?: Ticketpagetaken2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagetaken2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagetaken2(inputs)
	return de_ticketpagetaken2(inputs)
});
export { ticketpagetaken2 as "ticketPageTaken" }